import React, { PureComponent } from 'react';
import BasicButton from '../theme/buttons/BasicButton';
import FloatHeader from '../theme/headers/FloatHeader';
import { Link } from 'react-router-dom';

export default class AccessDenied extends PureComponent {
  render() {
    return (
      <div>
        <FloatHeader link="/" />
        <div className="container ">
          <div className="row access-denied">
            <div className="column column-50 column-offset-20">
              <h1 className="access-denied">Forbidden</h1>
              <span>You do not have access to this page or resource.</span>

              <div className="row" style={{ marginTop: '2em' }}>
                <div className="column column-25 column-offset-10">
                  <a className={'button'} onClick={() => (window.location = '/login')}>
                    Log Out
                  </a>
                </div>
                <div className="column column-25">
                  <a className={'button'} onClick={() => window.history.back()}>
                    Go Back
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
